import { observer } from 'mobx-react-lite'
import React, { useRef } from 'react'
import classNames from 'classnames'
import { Typography, ButtonEdit, Button, TextFieldWithLabel, Icon, IconButton } from 'shared/ui'
import { makeTextFieldElement } from 'shared/ui/TextField'
import { useReferralsViewContext } from 'pages/settings/pages/referrals/context/referralsViewContext'
import styles from './styles.module.scss'

export const ReferralsPayPal = observer(() => {
  const {
    email,
    emailLocalError,
    savedEmail,
    setEmail,
    checkIsEmail,
    isEmailSaved,
    isEditMode,
    setEditMode,
    showSaveButton,
    saveDisabled,
    onSave,
    onDelete,
    loading,
  } = useReferralsViewContext()
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div
      className={classNames(styles.container, {
        [styles.error]: !!emailLocalError,
      })}
    >
      <div className={styles.description}>
        <Typography
          variant='body-md-medium'
          color={'var(--content-primary-primary)'}
          ariaLabel='ReferralsPayPal_title'
          marginBottom={4}
        >
          Your PayPal email
        </Typography>
        <Typography
          className={styles.desc}
          variant='body-md-regular'
          color={'var(--content-primary-tertiary)'}
          ariaLabel='ReferralsPayPal_desc'
        >
          Add your PayPal email to get paid
        </Typography>
      </div>

      <div className={styles.emailFieldWrap}>
        <TextFieldWithLabel
          errorBorder={!!emailLocalError}
          errorMessage={emailLocalError}
          errorClassName={classNames(styles.emailError, {
            [styles.withAction]: showSaveButton,
          })}
          textFieldProps={{
            onFocus: () => {
              if (!isEditMode) return
            },
            value: email,
            onChange: setEmail,
            onBlur: checkIsEmail,
            InputProps: {
              ref: inputRef,
              placeholder: 'email@example.com',
            },
            className: classNames(styles.emailField, {
              [styles.withAction]: showSaveButton,
              [styles.hoverDisabled]: !isEditMode,
            }),
          }}
          marginLeft={'auto'}
          leftActions={[
            makeTextFieldElement({
              element:
                !isEditMode && isEmailSaved ? (
                  <Icon icon={'check2'} color={'var(--green-60)'} />
                ) : null,
            }),
          ]}
        />
        <div className={styles.update}>
          <ButtonEdit
            onClick={() => {
              setEditMode()
              inputRef.current?.focus()
            }}
            tag='div'
            show={!showSaveButton}
          />
        </div>
      </div>

      <div className={classNames(styles.actions)}>
        {showSaveButton && (
          <Button
            text={'Save'}
            typeBtn={'contained'}
            contained={'primary'}
            size={'large'}
            disabled={saveDisabled}
            onClick={onSave}
            loading={loading}
            className={classNames(styles.save)}
            aria-label='ReferralsPayPal_Email_save'
          />
        )}
        {/* TODO: https://salesmsg.atlassian.net/browse/SWR-19488 */}
        {false && showSaveButton && (
          <IconButton
            onClick={onDelete}
            color={'tertiary'}
            icon={'delete'}
            variant={'contained'}
            size={'large'}
            ariaLabel='ReferralsPayPal email delete'
            disabled={email !== savedEmail}
          />
        )}
      </div>
    </div>
  )
})
